import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import AboutSection from "../components/About";
import WhyChoose from "../components/WhyChoose";
import serviceBg from "../assets/hero3.png";
import "./About.css";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Customer Supports 24x7</title>
        <meta
          name="description"
          content="Customer Supports 24x7 provides doorstep appliance repair support across Bangalore."
        />
        <link rel="canonical" href="https://customersupports24x7.in/about" />
      </Helmet>

      <InnerBanner title="About Us" bgImage={serviceBg} />
      <AboutSection />
      <WhyChoose />
    </>
  );
};

export default About;
